
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industrial-design/[slug]",
      function () {
        return require("private-next-pages/industrial-design/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industrial-design/[slug]"])
      });
    }
  